export default {
    lang: {
        name: 'Group votes'
    }
}